
import Vue, { PropType } from 'vue'
import { SaIconsType } from '~/assets/ts/types/icons'
import SaIcon from '~/components/_general/SaIcon.vue'
import { IconGap, IconGapSizes } from '~/assets/ts/utils/classes'

export default Vue.extend({
  name: 'InlineIcon',
  components: { SaIcon },
  props: {
    icon: {
      type: String as PropType<SaIconsType>,
      required: true,
    },
    slotClasses: {
      type: String,
      default: '',
    },
    iconClasses: {
      type: String,
      default: '',
    },
    gapSize: {
      type: String as PropType<IconGap>,
      default: 'md',
    },
    flipSide: {
      type: Boolean,
    },
    hideIcon: {
      type: Boolean,
    },
  },
  computed: {
    gapClass(): string {
      return IconGapSizes(this.gapSize)
    },
  },
})
